import { FilterIcon, SearchIcon } from "@heroicons/react/outline";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import PlaceHolder from "../../../../components/placeHolder.tsx/PlaceHolder";
import { showApiErrorMessages } from "../../../../helpers";
import { ApiCommonParams } from "../../../../api/@types/apiTypes";
import { useInfiniteQuery, useQuery } from "react-query";
import { indexTutors } from "../../../../api/endpoints/supervisors/tutors";
import TutorModel from "../../../../api/models/TutorModel";
import TutorCard from "../../../../components/tutor-card";
import LoadingSpinner from "../../../../components/LoadingSpinner";

export default function TutorsView() {
  const LocalBasePath = "page.supervisor.tutor";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [filters, setFilters] = useState<{ [key: string]: any }>({});
  let [currentPageNumber, setCurrentPageNumber] = useState<number>(1);
  // const [isLoading, setIsLoading] = useState<boolean>(true);

  const resetCurrentPage = () => {
    setCurrentPageNumber(1);
  };
  const {
    data: tutorsPages,
    fetchNextPage: fetchNextPageStudents,
    isLoading,
  } = useInfiniteQuery(
    ["studentsData", filters],
    ({ pageParam = 1 }) => {
      return indexTutors({
        filters,
        pagination: {
          pageSize: 25,
          pageNumber: pageParam,
        },
      });
    },
    {
      select: (data) => {
        let fetchedStudents: TutorModel[] = [];

        return {
          pages: data.pages
            .map((pageResponse) => {
              if (pageResponse.isSuccess) {
                fetchedStudents = TutorModel.fromApiResponse(pageResponse.data);
              }
              return fetchedStudents;
            })
            .flat(),
          pageParams: data.pageParams,
        };
      },
      cacheTime: 0,
    }
  );
  const tutors = useMemo(() => {
    if (tutorsPages) {
      return tutorsPages.pages.flat();
    }
    return [];
  }, [tutorsPages]);

  useEffect(() => {
    resetCurrentPage();
  }, [filters]);
  useEffect(() => {
    const element = document.getElementById("scroll_container");

    const handleScroll = () => {
      if (!!element) {
        const { clientHeight, scrollTop, scrollHeight } = element;
        const bottom: boolean =
          Math.floor(scrollHeight - scrollTop) <= clientHeight;
        if (bottom) {
          setCurrentPageNumber((prev) => prev + 1);
        }
      }
    };
    if (!!element) element.addEventListener("scroll", handleScroll);

    return () => {
      if (!!element) element.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    fetchNextPageStudents({ pageParam: currentPageNumber });
  }, [currentPageNumber]);
  return (
    <div className="flex flex-col justify-between w-full min-h-screen bg-gray-50 ">
      <div className="flex flex-col h-full min-w-full w-fit">
        <div className="flex items-center justify-between p-4 text-gray-900 ">
          <h2 className="text-2xl">{t("reciters")}</h2>
        </div>
        <div className="relative mx-4 mt-1 rounded-md shadow-sm">
          <div className="absolute inset-y-0 flex items-center pointer-events-none start-0 ps-3">
            <SearchIcon className="w-5 h-5 text-gray-400" aria-hidden="true" />
          </div>
          <input
            type="text"
            name="search"
            id="search"
            className="block w-full border-gray-300 rounded-md focus:ring-brandblue-500 focus:border-brandblue-500 ps-10 sm:text-sm"
            placeholder={t("search")}
            onChange={(e) => setFilters({ q: e.target.value })}
          />
        </div>

        {!!tutors && tutors.length > 0 ? (
          <div className="grid items-center justify-center w-full grid-cols-1 gap-6 px-6 mx-auto mt-6 sm:grid-cols-2 md:grid-cols-3 ">
            {tutors.map((tutor) => (
              <>
                <TutorCard tutor={tutor} />
              </>
            ))}
          </div>
        ) : (
          <div className="flex items-center justify-center w-full h-full">
            {!isLoading && <PlaceHolder title="noRecitersTitle" />}{" "}
          </div>
        )}
        {isLoading && (
          <div className="min-h-[80vh] w-full flex justify-center items-center">
            <LoadingSpinner size={100} />
          </div>
        )}
      </div>
    </div>
  );
}
